module.exports = __webpack_public_path__ + "img/plus-circle.d3c5575c.svg";